import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { Button } from "react-bootstrap";
import DayPicker from "utils/DayPicker";
import jsDig from "utils/jsDig";

export default function Activity(props) {
  const logs = props.logs;
  const [renderLogs, setRenderLogs] = useState(logs.slice(0, 20));
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const loadMore = () => {
    if (renderLogs.length >= logs.length) {
      alert("There are no more logs");
    } else {
      setRenderLogs([...renderLogs, ...logs.slice(renderLogs.length, Math.min(renderLogs.length + 20, logs.length))]);
    }
  };
  const showLoadBtn = () => {
    if (logs.length > 0 && renderLogs.length < logs.length) {
      return true;
    }
    return false;
  }

  return (
    <div style={{paddingBottom: "210px"}}>
      <h1 style={{paddingBottom: "25px"}}>DataPulse Change History</h1>
      <DayPicker startDate={props.date} dateParam={props.date_param} />
      <ul style={{paddingTop: "10px", paddingLeft: "0px"}}>
        {renderLogs.map((log, index) => {
          const user = props.users.find((el) => el.id == log["who_dunn_it"]);
          const userEmail = user.email;
          const client = props.clients.find((el) => el.id == log["client_id"]);
          const time = moment(log.updated_at).format("YYYY-MM-DD hh:mm A");
          let userName = "";
          if (log.table == "users") {
            userName = props.users.find((el) => el.id == log["client_id"]);
          }
          const createOrUpdate = log.version == 1 ? "created with value" : "updated";
          const fieldNames = Object.keys(log.log_data);
          const valuesChange = Object.values(log.log_data);

          return (
            <li key={index} className="mb-2" style={{ listStyle: "none" }}>
              <Accordion onChange={(e) => {
                  console.log(this)
                  const icon = $(e.target).find(".fas");
                  if (icon.hasClass("fa-sort-up")) {
                    icon.removeClass("fa-sort-up").addClass("fa-sort-down");
                  } else {
                    icon.removeClass("fa-sort-down").addClass("fa-sort-up");
                  }
                }}
              >
                <AccordionSummary>
                  <p>
                    {log.table == "users"
                      ? `${userEmail} updated user ${userName.email} info at ${time} `
                      : `${userEmail} ${createOrUpdate} ${log.table} for ${jsDig(["company_name"], client)} at ${time} `}
                  </p>
                  <p style={{ marginLeft: "2em" }} className="read-more"><i className={`fas ${"fa-sort-down"}`}></i> Read more</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ul style={{wordBreak: "break-word"}}>
                    {fieldNames.map((field, index) => {
                      if (field !== "updated_at" && field !== "created_at" && field !== "id") {
                        let detailsChange = `${field} was ${createOrUpdate} ${
                          log.version > 1
                            ? `from ${
                                JSON.stringify(jsDig(["previous_data", field], log)) && JSON.stringify(jsDig(["previous_data", field], log)).replace(/\\/g, "")
                              }`
                            : ""
                        }
                        ${log.version > 1 ? " to " : ""} 
                        ${JSON.stringify(valuesChange[index]).replace(/\\/g, "")}  `;
                        if (log.landing_page_id) {
                          detailsChange = `Landing Page ${
                            props.landing_page_groups.find((el) => el.id == log.landing_page_id).name
                          } ${field} is ${createOrUpdate} ${
                            log.version > 1
                              ? `from ${
                                  JSON.stringify(jsDig(["previous_data", field], log)) &&
                                  JSON.stringify(jsDig(["previous_data", field], log)).replace(/\\/g, "")
                                }`
                              : ""
                          }  to ${JSON.stringify(valuesChange[index]).replace(/\\/g, "")}`;
                        }
                        if (log.table == "campaign_groups") {
                          const campaign = props.campaign_groups.find((el) => el.id == log.campaign_id);
                          detailsChange = `Campaign Group ${campaign.name} for ${campaign.section_type} ${field} is ${createOrUpdate} ${
                            log.version > 1
                              ? `from ${
                                  JSON.stringify(jsDig(["previous_data", field], log)) &&
                                  JSON.stringify(jsDig(["previous_data", field], log)).replace(/\\/g, "")
                                }`
                              : ""
                          }  to ${JSON.stringify(valuesChange[index]).replace(/\\/g, "")}`;
                        }
                        if (log.table == "campaign_groups_social") {
                          const campaign = props.campaign_groups_social.find((el) => el.id == log.campaign_social_id);
                          detailsChange = `Campaign Group ${campaign.name} for ${campaign.section_type} ${field} is ${createOrUpdate} ${
                            log.version > 1
                              ? `from ${
                                  JSON.stringify(jsDig(["previous_data", field], log)) &&
                                  JSON.stringify(jsDig(["previous_data", field], log)).replace(/\\/g, "")
                                }`
                              : ""
                          }  to ${JSON.stringify(valuesChange[index]).replace(/\\/g, "")}`;
                        }
                        return <li key={index}>{detailsChange}</li>;
                      }
                    })}
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li>
          );
        })}
      </ul>
      <Button onClick={loadMore} style={{display: showLoadBtn() ? "block" : "none", marginLeft: "5px"}}> Load more</Button>
      <Button onClick={scrollToTop} style={{ position: "fixed", bottom: "10px", right: "5px" }}>
        Scroll to Top
      </Button>
    </div>
  );
}
